<template>
  <div>
    <PageHeader :title="trans('user.invoice.title')" />
    <div class="container invoice">
      <div class="row">
        <div class="gr-12">
          <invoice-sort
            class="invoice-sort"
            :sort="`${sortField}-${sortOrder}`"
            @change="setSortFromDropdown"
          />
          <invoices-list
            :loading="loading"
            :invoices="invoices"
            :sort-field="sortField"
            :sort-order="sortOrder"
            @set-sort="setSort"
          />

          <pagination
            v-if="nbPages > 1"
            :page="page"
            :nb-pages="nbPages"
            :nb-items="nbTotalItems"
            :offset-start="offsetStart"
            :offset-end="offsetEnd"
            @go-page="setUrl"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from '@components-molecules/PageHeader.vue';
import Pagination from '@components/Pagination.vue';
import { flashBagError } from '@tools/flashbag';
import { Logger } from '@tools/logger/logger';
import { translationMixin } from '@elements/translation';
import {
  URL_INVOICE,
} from '@tools/routes/routes';
import { requestsMixin } from '@tools/requests-mixin';

import InvoicesList from './InvoicesList.vue';
import InvoiceSort from './components/InvoiceSort.vue';

export default {
  name: 'InvoiceApp',
  components: {
    PageHeader,
    InvoiceSort,
    InvoicesList,
    Pagination,
  },
  mixins: [ translationMixin, requestsMixin ],
  data() {
    return {
      loading: false,
      nbItemsPerPage: 10,
      invoices: [],
      nbTotalItems: 0,
      sortField: 'created',
      sortOrder: 'desc',
      page: 1,
    };
  },
  computed: {
    nbPages() {
      return Math.ceil(this.nbTotalItems / this.nbItemsPerPage);
    },
    offsetStart() {
      return (this.page - 1) * this.nbItemsPerPage + 1;
    },
    offsetEnd() {
      return Math.min(this.page * this.nbItemsPerPage, this.nbTotalItems);
    },
  },
  watch: {
    sort(value) {
      this.splitSort(value);
    },
    $route(to) {
      if (to.params.page) {
        this.page = parseInt(to.params.page, 10);
      }
      if (to.params.sort) {
        this.splitSort(to.params.sort);
      }
    },
  },
  mounted() {
    // Initialize app with preloaded data passed into twig
    if (Object.keys(window.initialAppState).length > 0) {
      this.setInvoices(window.initialAppState.invoices);
      this.nbTotalItems = window.initialAppState.pagination.nb_total_items;
      this.nbItemsPerPage = window.initialAppState.pagination.nb_items_per_page;
      this.sortField = window.initialAppState.sort.field;
      this.sortOrder = window.initialAppState.sort.order;
    }
  },
  methods: {
    async setUrl(page, sortField = this.sortField, sortOrder = this.sortOrder) {
      const route = { name: 'invoice', params: {} };
      if (page > 1) {
        route.params.page = page;
      }

      if (sortField !== null) {
        route.params.sort = `${sortField}-${sortOrder}`;
        route.params.page = page;
      }

      if (await this.loadInvoices(page, sortField, sortOrder)) {
        this.$router.push(route);
      }
    },
    splitSort(value) {
      [ this.sortField, this.sortOrder ] = value.split('-');
    },
    setSort(sortField, sortOrder = null) {
      if (sortOrder) {
        this.setUrl(1, sortField, sortOrder);
        return;
      }

      if (this.sortField === sortField) {
        this.setUrl(
          this.page,
          this.sortField,
          this.sortOrder === 'asc' ? 'desc' : 'asc',
        );
        return;
      }
      this.setUrl(1, sortField, 'asc');
    },
    setSortFromDropdown(rawSort) {
      const splitted = rawSort.split('-');
      const sortField = splitted[0];
      const sortOrder = splitted[1];
      this.setSort(sortField, sortOrder);
    },

    setInvoices(invoices) {
      this.invoices = invoices;
    },
    /**
     * Load invoices from backend
     */
    async loadInvoices(page, sortField, sortOrder) {
      this.loading = true;

      const queryParams = new URLSearchParams();
      const endpoint = URL_INVOICE.replace('{page}', page)
        .replace('{sortField}', sortField)
        .replace('{sortOrder}', sortOrder);

      return this
        .get(
          endpoint
            + (queryParams.toString() !== '' ? `?${queryParams.toString()}` : ''),
        )
        .then((response) => response.data)
        .then((json) => {
          this.loading = false;
          this.setInvoices(json.invoices);
          this.nbTotalItems = json.pagination.nb_total_items;

          return true;
        })
        .catch((err) => {
          Logger.error('Error catched', err);
          flashBagError();
          this.loading = false;
          return false;
        });
    },
  },
};
</script>
